export default {
  performanceMetrics: {
    activeUsers: "Aktivní uživatelé",
    creditsUsed: "Použité kredity",
    avgCompletionRate: "Průměr. míra dokončení",
    topUsers: "Nejaktivnější uživatelé",
    noActiveUsers: "Žádní aktivní uživatelé",
  },

  userActivityTable: {
    title: "Aktivita uživatelů",
    searchPlaceholder: "Hledat uživatele...",
    users: "uživatelů",
    headers: {
      name: "Jméno",
      email: "Email",
      activities: "Aktivity",
      creditsUsed: "Použité kredity",
      creditsRemaining: "Zbývající kredity",
      completionRate: "Míra dokončení",
      lastActivity: "Poslední aktivita",
      status: "Stav",
      actions: "Akce",
    },
    viewDetails: "Zobrazit detaily",
    active: "Aktivní",
    inactive: "Neaktivní",
    dormant: "Nečinný",
    neverActive: "Nikdy aktivní",
    never: "Nikdy",
    noUsers: "Žádní uživatelé",
    noUsersDescription: "V tuto chvíli nejsou k dispozici žádní uživatelé.",
  },

  lessonProgressChart: {
    title: "Pokrok v kurzech",
    timeRange: "Období: {days} dní",
    totalUsers: "Celkem uživatelů",
    avgCompletion: "Průměr. dokončení",
    topPerformers: "Nejlepší výsledky",
    noData: "Žádná data k zobrazení",
  },

  creditUsageChart: {
    title: "Využití kreditů",
    totalCredits: "Celkem kreditů",
    usedCredits: "Použité kredity",
    availableCredits: "Dostupné kredity",
    utilizationRate: "Míra využití",
    distributionRate: "Míra distribuce",
    utilization: "Využití",
    topUsers: "Největší spotřebitelé kreditů",
    used: "Použito",
    distributed: "Distribuováno",
    available: "Dostupné",
    allocation: "Alokace kreditů",
    noUsage: "Žádné využití kreditů",
  },

  recentActivity: {
    title: "Nedávná aktivita",
    lastDays: "Posledních {days} dní",
    journeyStarted: "Začal kurz",
    challengeStarted: "Začal výzvu",
    gymStarted: "Začal trénink",
    learningPath: "Vzdělávací cesta",
    trainingSession: "Tréninková relace",
    status: {
      completed: "Dokončeno",
      inProgress: "Probíhá",
      failed: "Neúspěšné",
      unknown: "Neznámé",
    },
    timeAgo: {
      seconds: "před {count} sekundami",
      minutes: "před {count} minutami",
      hours: "před {count} hodinami",
      days: "před {count} dny",
    },
    noActivity: "Žádná aktivita",
    noActivityDescription: "Žádná aktivita zaznamenána za posledních {days} dní.",
    viewAll: "Zobrazit vše",
  },

  userDetailModal: {
    never: "Nikdy",
    close: "Zavřít",
    stats: {
      totalActivities: "Celkem aktivit",
      creditsUsed: "Použité kredity",
      completionRate: "Míra dokončení",
      avgSessionTime: "Průměr. doba relace",
    },
    userInfo: {
      title: "Informace o uživateli",
      lastSignIn: "Poslední přihlášení",
      creditsAllocated: "Přidělené kredity",
      creditsRemaining: "Zbývající kredity",
      lessonsCompleted: "Dokončené kurzy",
      gamesCompleted: "Dokončené hry",
    },
    progress: {
      title: "Pokrok",
      creditUtilization: "Využití kreditů",
      lessonCompletion: "Dokončení kurzů",
    },
    recentGames: {
      title: "Nedávné hry",
      noGames: "Žádné nedávné hry",
    },
    recentJourneys: {
      title: "Nedávné kurzy",
      learningPath: "Vzdělávací cesta",
      progress: "Krok {reached}/{total}",
      noJourneys: "Žádné nedávné kurzy",
    },
    status: {
      completed: "Dokončeno",
      inProgress: "Probíhá",
      failed: "Neúspěšné",
      unknown: "Neznámé",
    },
    moduleType: {
      challenge: "Výzva",
      gym: "Trénink",
      unknown: "Neznámé",
    },
  },
};
